export interface FacilityDto {
  id: number;
  name: string;
}

export class CorrectionalFacilityUserDto {
  userId?: number = -1;
  email: string = "";
  name: string = "";
  correctionalFacilityId: number = -1;
  facilityIds: number[] = [-1];
  password?: string = "";

  constructor(init?: Partial<CorrectionalFacilityUserDto>) {
    Object.assign(this, init);
  }

  static fromResponse(res: CorrectionalFacilityUserResponse): CorrectionalFacilityUserDto {
    return new CorrectionalFacilityUserDto({
      userId: res.id,
      name: res.name,
      email: res.email,
      correctionalFacilityId: res.correctionalFacilityId,
      facilityIds: res.correctionalFacilities.map(f => f.id),
    });
  }
}

export interface CorrectionalFacilityUserResponse {
  id: number;
  name: string;
  email: string;
  correctionalFacilityId: number;
  correctionalFacilities: FacilityDto[];
}